import { ReportOptions } from '@showbie-socrative/socrative-utils';

export interface BooleanReportOption {
  label: string;
  identifier: ReportOptions;
  type: 'boolean';
}

export const MCAnswerContent: BooleanReportOption = {
  identifier: ReportOptions.IncludeMultipleChoiceContent,
  label: 'Include Multiple-Choice Answer Content',
  type: 'boolean',
};

export const IncludeExplanations: BooleanReportOption = {
  identifier: ReportOptions.IncludeExplanations,
  label: 'Include Explanations',
  type: 'boolean',
};

export const IncludeCorrectAnswers: BooleanReportOption = {
  identifier: ReportOptions.IncludeCorrectAnswers,
  label: 'Include Correct Answers',
  type: 'boolean',
};

export const ProOnlyReportOptions = [
  ReportOptions.IncludeExplanations,
  ReportOptions.IncludeCorrectAnswers,
  ReportOptions.IncludeMultipleChoiceContent,
];

export type ReportOptionType = BooleanReportOption;
